export default __webpack_public_path__ + "static/media/threeDots-white.0c2dd472.svg";